import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_COMPARE = (body) => {
    return axiosIns.get(`monitoring-custom?${body}`);
};
